import { CSSObject } from '@chakra-ui/react';
import { ContainerForms } from '../../styles/account.styles.fiestabet';
import { CustomButtonProps } from '@/components/Button/Button';

export const ListItemExclusionItem: CSSObject = {
  fontSize: 'xs',
  color: 'white',
};

export const HeadingInformation: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'medium',
  mb: '1',
  color: 'white',
};

export const TextInformation: CSSObject = {
  fontSize: 'xs',
  mb: '3',

  _first: {
    fontWeight: 'medium',
  },
  color: 'white',
};

export const BoxStyledLink: CSSObject = {
  color: 'white',
  textDecoration: 'underline',
};

export const TextM: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'medium',
  mb: '1',
  color: 'white',
};

export const TextS: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'medium',
  color: 'white',
};

export const BoxTakeABreak: CSSObject = {
  border: '0',
  pb: '0',
};

export const TextDate: CSSObject = {
  fontSize: 'md',
};

export const TextDateLabel: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'medium',
};

export const TextConfirmBreak: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'medium',
};

export const BoxTakeABreakWrapper: CSSObject = {
  border: '0',
  pb: '0',
};

export const InputContainer: CSSObject = {
  color: 'white',
  ...ContainerForms,

  '.chakra-form__label': {
    color: 'white',
    ...TextDateLabel,
  },
  '.chakra-select': {
    borderRadius: 'lg',
  },
};

export const buttonTakeBreakProps: CustomButtonProps = {
  variant: 'secondary',
  lineHeight: 'normal',
};

export const TakeABreakContainer: CSSObject = {
  color: 'white',
  m: '0',
  pb: '3',
  border: 'none',
};

export const buttonConfirmBreakProps: CustomButtonProps = {
  height: '38px',
  variant: 'secondary',
};
